module.exports = __webpack_public_path__ + "img/second-day-7.c0aba3dd.webp";